<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <vx-card class="mb-2">
      <div class="vx-row mb-2">
        <div class="vx-col w-full ml-5">
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-8/12 flex-inline">
              <vs-input
                v-model="filter"
                class="w-full"
                v-focus
                @keyup.enter="
                  pageNo = 1;
                  getData();
                "
              />
            </div>
            <div class="vx-col sm:w-2/12 flex-inline">
              <vs-button
                @click="
                  pageNo = 1;
                  getData();
                "
                class="mx-3"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-search"
                >جستجو</vs-button
              >
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card class="mb-2">
      <vs-table
        id="tbl2"
        ref="tbl2"
        :data="users2"
        class="table-dark-inverted"
        @selected="selected"
      >
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-2/3 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                      >
                        <span class="mr-2">
                          {{ (pageNo - 1) * pageSize + 1 }}
                          -
                          {{
                            pageNo * pageSize > totalCount
                              ? totalCount
                              : pageNo * pageSize
                          }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon
                          icon="ChevronDownIcon"
                          svgClasses="h-4 w-4"
                        />
                      </div>
                      <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th>شماره همراه</vs-th>
          <vs-th>نام و نام خانوادگی</vs-th>
          <!-- <vs-th>نام</vs-th>
          <vs-th>نام خانوادگی</vs-th>-->
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="tr.id" v-for="(tr, indextr) in data">
            <vs-td>
              <span>{{ tr.userName }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.fullName }}</span>
            </vs-td>
            <!-- <vs-td>
              <span>{{tr.firstName}}</span>
            </vs-td>
            <vs-td>
              <span>{{tr.lastName}}</span>
            </vs-td>-->
            <vs-td>
              <a @click="showBills(tr.id, tr.userName)">قبضهای‌دریافتی</a>
            </vs-td>
            <vs-td>
              <a @click="showTransaction(tr.id, tr.fullName || tr.userName)"
                >تراکنشها</a
              >
            </vs-td>
            <!-- <vs-td>
              <vs-dropdown>
                <a class="flex items-center" href.prevent>
                  عملیات
                  <i class="material-icons">expand_more</i>
                </a>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="manageRoles(tr.id,tr.userName)"
                  >مدیریت نقشها</vs-dropdown-item>
                  <vs-dropdown-item
                    @click="manageDepartments(tr.id,tr.userName)"
                  >مدیریت دپارتمانها</vs-dropdown-item>
                  <vs-dropdown-item
                    @click="managePermissions(tr.id,tr.userName)"
                  >مدیریت مجوزها</vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>-->
          </vs-tr>
        </template>
      </vs-table>

      <paginate
        v-model="pageNo"
        :page-count="pagesCount"
        :click-handler="getData"
      />
    </vx-card>
  </div>
</template>
<style>
.nav-transacttions > .vs-popup {
  width: 100%;
}
</style>
<script>
import vSelect from "vue-select";
import { MerchantStatus, Colors } from "@/enums.js";
import Vue from "vue";
export default {
  props: {
    transactions: {},
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      users2: [],
      Colors,
      totalCount: 1,
      pageSize: 10,
      pagesCount: 1,
      pageNo: 1,
      filter: "",
    };
  },
  computed: {},
  methods: {
    initFilters() {
      if (Object.keys(this.$route.query).length != 0) {
        this.pageSize = this.$route.query.ps || this.pageSize;
        this.pageNo = parseInt(this.$route.query.pno) || this.pageNo;
        this.filter = this.$route.query.f || this.filter;
      }
    },
    getData() {
      const query = {
        ps: this.pageSize,
        pno: this.pageNo,
      };
      if (this.filter) query.f = this.filter;
      this.$router.replace({
        query: query,
      });

      let loading = this.$vs.loading();
      let payload = {
        params: {
          MaxResultCount: this.pageSize,
          SkipCount: this.pageSize * (this.pageNo - 1),
          Filter: this.filter,
        },
      };

      this.$http
        .get("/api/services/app/User/GetConsumers", payload)
        .then((response) => {
          this.users2 = response.data.result.items;
          this.totalCount = response.data.result.totalCount;
          this.pagesCount = Math.ceil(this.totalCount / this.pageSize);
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    showBills(userId, username) {
      this.$router.push({
        name: "ConsumerSingleBills",
        query: {
          title: username,
          userId: userId,
        },
      });
    },
    selected(tr) {
      //this.showTransaction(tr.transaction.id);
    },
    showTransaction(userId, title) {
      this.$router.push({
        name: "ConsumerTransactions",
        query: {
          t: title,
          sid: userId,
        },
      });
    },
  },
  mounted() {
    if (this.$route.query.pno) {
      this.initFilters();
      this.getData();
    }
  },
};
</script>
